<template>
  <div v-if="toast" class="ui-toast" :class="toast.kind === 'err' && 'ui-toast--err'" :role="toast.kind === 'err' ? 'alert' : 'status'" aria-live="polite">
    <v-icon v-if="toast.kind" size="18" color="currentColor">{{ toast.kind === "err" ? "mdi-alert-outline" : "mdi-check" }}</v-icon>
    <span>{{ toast.text }}</span>
    <button v-if="toast.action" type="button" @click="$emit('action')">{{ toast.label }}</button>
  </div>
</template>

<script>
/** Kratko obavještenje na dnu ekrana, sa opcionom radnjom (npr. "Poništi"). toast: { text, label, action, kind? } ili null; kind "err" (crveno, alert) ili "ok" daje ikonu; radnja se javlja kao `action`. */
export default {
  name: "UiToast",
  props: { toast: { type: Object, default: null } },
};
</script>
